export default class MultiStateObject {

    constructor() {
        this.active = false;
        this.stateName = '';
        this.item = undefined;
    }

}
